var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-service", on: { click: _vm.selectBox } },
    [
      _c("div", { staticClass: "post-image" }, [
        _c("div", { staticClass: "position-absolute list-image" }, [
          _c("div", { staticClass: "center-elements image-bg" }, [
            _vm.image
              ? _c("img", { attrs: { width: "100%", src: _vm.image } })
              : _c(
                  "div",
                  { staticClass: "camera-icon" },
                  [_c("icon", { attrs: { name: "camera", scale: "2" } })],
                  1
                )
          ]),
          _vm._v(" "),
          _vm.isOferlayShown
            ? _c("div", { class: _vm.getOverlayClass }, [
                _c("div", { staticClass: "center-elements" }, [
                  _vm.selectable
                    ? _c(
                        "div",
                        { staticClass: "post-selection-overlay text-center" },
                        [
                          _c("q-icon", {
                            attrs: {
                              allowSelfUpdate: false,
                              className: _vm.getConnectedClass,
                              name: "connected",
                              width: "45px"
                            },
                            on: { click: _vm.selectBox }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editable
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "post-selection-overlay text-center buttons"
                        },
                        [
                          _c("input-button", {
                            staticClass: "mt-2 ml-2 mr-2",
                            attrs: {
                              pointable: "",
                              hollow: "",
                              smaller: "",
                              variant: "standardInput",
                              btnStyle: "ok-style",
                              inputPlaceholder: _vm.$t("Button.edit")
                            },
                            on: { click: _vm.editPost }
                          }),
                          _vm._v(" "),
                          _c("input-button", {
                            staticClass: "mt-2 ml-2 mr-2",
                            attrs: {
                              pointable: "",
                              hollow: "",
                              smaller: "",
                              variant: "standardInput",
                              btnStyle: "nok-style",
                              inputPlaceholder: _vm.$t("Button.remove")
                            },
                            on: { click: _vm.deletePost }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "post-body" }, [
        _c("div", { class: _vm.getPostContentStyle }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getPostPricingStyle }, [
          _c("p", { staticClass: "font-weight-bold" }, [
            _c("span", { class: { "float-right": true, "ml-1": true } }, [
              _c(
                "span",
                {
                  class: {
                    "invalid-price": _vm.getDiscount.discount,
                    price: !_vm.getDiscount.discount
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getPrice) +
                      " \n            EUR\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.getDiscount.discount
                ? _c("span", { staticClass: "price" }, [
                    _vm._v(
                      "\n\n            " +
                        _vm._s(_vm.getDiscountedPrice) +
                        "\n            EUR\n          "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.getDiscount.discount
              ? _c("span", { staticClass: "discount-tag" }, [
                  _vm._v(
                    "\n\n          " +
                      _vm._s(_vm.getAdvertisableDisplayDiscount) +
                      " \n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getQuantity
              ? _c("span", { staticClass: "float-right float-md-left ml-4" }, [
                  _vm._v(
                    "\n\n          " + _vm._s(_vm.getQuantity) + "x\n        "
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e69a970", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e69a970","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/postList/ItemList.vue
// module id = null
// module chunks = 